import { LevelDesignerComponent } from '../../level-designer/level-designer.component';
import { PropertyEditor } from '../property-editor';
import { TextInput } from './text-input';

export class NumberInput extends TextInput {
    constructor(
        ctx: CanvasRenderingContext2D,
        x: number,
        y: number,
        width: number,
        height: number,
        value: number,
        isActive: boolean,
        levelDesigner: LevelDesignerComponent,
        propertyEditor: PropertyEditor,
        private min?: number,
        private max?: number,
    ) {
        super(ctx, x, y, width, height, value, isActive, levelDesigner, propertyEditor);
    }

    protected override isValidInputCharacter(key: string, currentValue: string, cursorPosition: number): boolean {
        // Allow numbers
        if (/[0-9]/.test(key)) {
            return true;
        }

        // Allow decimal point if there isn't one already
        if (key === '.' && !currentValue.includes('.')) {
            return true;
        }

        // Allow minus sign only at the start and if there isn't one already
        if (key === '-' && cursorPosition === 0 && !currentValue.includes('-')) {
            return true;
        }

        return false;
    }

    getNumberValue(): number {
        return parseFloat(this.getValue());
    }
} 
